import React from 'react';
export var ScreenReaderOnly = function (props) {
    var message = props.message, role = props.role;
    return (React.createElement("div", { className: "absolute left-[-10000px] top-auto h-0.25 w-0.25 overflow-hidden", role: role }, message));
};
